export const environment = {
  production: true,
  buildId: '3226003685620951',
  configFile: 'config.json',
};
